import React from 'react';
import { BaseCellContent, IconOnly, TextOnly } from './CellContent.styles';
import CheckCircleLine from 'app/icons/Monospaced/CheckCircle/CheckCircleLine';
import { cssVar } from 'styles/helper';
import Typography from 'atoms/Typography/Typography';
import AnchorCellHandler from './AnchorCellHandler';
import { useSEOTableConfig } from './useSEOTableConfig';

interface CellContentProps {
  text: string;
  checked: boolean;
  href?: string;
}

const CellContent = ({ text, checked, href }: CellContentProps): JSX.Element => {
  const { textAlignment } = useSEOTableConfig();

  const hasText = !!text;
  const hasChecked = typeof checked === 'boolean';

  const icon = (() => {
    const hasCheckedIcon = typeof checked === 'boolean';
    if (!hasCheckedIcon) {
      return null;
    }

    return checked ? (
      <CheckCircleLine
        width={20}
        color={cssVar('fg-success-primary')}
      />
    ) : (
      <Typography
        type='paragraph'
        size='sm'
      >
        -
      </Typography>
    );
  })();

  const textParagraph = text && (
    <AnchorCellHandler href={href}>
      <Typography
        type='paragraph'
        size='sm'
        fontWeight='font-weight-regular'
        color='text-tertiary'
        textAlign={textAlignment}
        whiteSpace='pre-line'
      >
        {text}
      </Typography>
    </AnchorCellHandler>
  );

  if (!hasText && hasChecked) {
    return <IconOnly>{icon}</IconOnly>;
  }

  if (hasText && !hasChecked) {
    return <TextOnly>{textParagraph}</TextOnly>;
  }

  return (
    <BaseCellContent>
      {icon}
      {textParagraph}
    </BaseCellContent>
  );
};

export default CellContent;
